import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import PostFilePicker from "./PostFilePicker";

const PostFilePickerModal = ({ title, onClose, ...rest }) => (
  <Modal
    autoFocus={false}
    returnFocusOnClose={false}
    isOpen
    onClose={onClose}
    size="2xl"
  >
    <ModalOverlay />
    <ModalContent>
      {title ? <ModalHeader>{title}</ModalHeader> : null}
      <ModalBody padding="0">
        <PostFilePicker {...rest} />
      </ModalBody>
      <ModalCloseButton />
    </ModalContent>
  </Modal>
);

PostFilePickerModal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

PostFilePickerModal.defaultProps = {
  title: undefined,
};

export default PostFilePickerModal;
